import FadeIn from "react-fade-in";

export default function Terms() {
  return (
    <FadeIn delay={100}>
      <div className="jumbotron">
        <h2>Lorem Ipsum Dolor Sit Amet Consectetur</h2>
        <h3 id="terms-text">1. Lorem</h3>
        <p>
          Sed ut perspiciatis unde omnis iste natus error sit voluptatem
          accusantium doloremque laudantium, totam rem aperiam, our{" "}
          <a href="https://dev.to/privacy">Eaque Ipsa</a>, quae ab illo
          inventore veritatis et quasi architecto beatae vitae dicta sunt
          explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur
          aut odit aut fugit, sed quia consequuntur magni dolores eos qui
          ratione voluptatem sequi nesciunt. Neque porro quisquam est qui
          dolorem ipsum quia dolor sit amet consectetur adipisci velit.
        </p>

        <h3 id="use-licence">2. Consectetur Adipisci</h3>

        <ol type="a">
          <li>
            Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,
            consectetur, adipisci velit, sed quia non numquam eius modi tempora
            incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut
            enim ad minima veniam, quis nostrum exercitationem ullam:
            <ol type="i">
              <li>corporis suscipit laboriosam nisi ut aliquid;</li>
              <li>
                ex ea commodi consequatur autem vel eum iure reprehenderit qui
                in ea voluptate velit esse;
              </li>
              <li>
                quam nihil molestiae consequatur vel illum qui dolorem eum
                fugiat quo voluptas nulla pariatur;
              </li>
              <li>
                at vero eos et accusamus et iusto odio dignissimos ducimus qui
                blanditiis; aut
              </li>
              <li>
                praesentium voluptatum deleniti atque corrupti quos dolores et
                quas molestias excepturi sint occaecati.
              </li>
            </ol>
          </li>
          <li>
            Et harum quidem rerum facilis est et expedita distinctio, nam
            libero tempore, cum soluta nobis est eligendi optio cumque nihil
            impedit quo minus id quod maxime placeat facere possimus, omnis
            voluptas assumenda est, omnis dolor repellendus temporibus autem
            quibusdam et aut officiis debitis aut rerum necessitatibus saepe
            eveniet.
          </li>
        </ol>

        <h3 id="disclaimer">3. Dignissimos</h3>

        <ol type="a">
          <li>
            Nam libero tempore, cum soluta nobis est eligendi optio cumque
            nihil impedit quo minus id quod maxime placeat. Itaque earum rerum
            hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus
            maiores alias consequatur aut perferendis doloribus asperiores
            repellat. Temporibus autem quibusdam et aut officiis debitis aut
            rerum necessitatibus saepe eveniet ut et voluptates repudiandae
            sint et molestiae non recusandae numquam eius modi tempora incidunt
            ut labore et dolore.
          </li>
        </ol>

        <h3 id="limitations">4. Voluptatem</h3>

        <p>
          Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse
          quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat
          quo voluptas nulla pariatur, at vero eos et accusamus et iusto odio
          dignissimos ducimus qui blanditiis praesentium voluptatum deleniti
          atque corrupti quos dolores et quas molestias excepturi sint
          occaecati cupiditate non provident, similique sunt in culpa qui
          officia deserunt mollitia animi id est laborum et dolorum fuga et
          harum quidem rerum facilis est et expedita distinctio.
        </p>

        <h3 id="revisions-and-errata">5. Repudiandae Sint</h3>

        <p>
          Temporibus autem quibusdam et aut officiis debitis aut rerum
          necessitatibus saepe eveniet ut et voluptates repudiandae sint et
          molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente
          delectus, ut aut reiciendis voluptatibus maiores alias consequatur
          aut perferendis doloribus asperiores repellat quo minus id quod
          maxime placeat facere possimus.
        </p>

        <h3 id="links">6. Molestiae</h3>

        <p>
          Nam libero tempore cum soluta nobis est eligendi optio cumque nihil
          impedit quo minus id quod maxime placeat facere possimus omnis
          voluptas assumenda est omnis dolor repellendus. Temporibus autem
          quibusdam et aut officiis debitis aut rerum necessitatibus saepe
          eveniet ut et voluptates repudiandae sint et molestiae non
          recusandae.
        </p>

        <h3 id="copyright-takedown">7. Reiciendis Voluptatibus</h3>

        <p>
          Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis
          voluptatibus maiores alias consequatur aut perferendis doloribus
          asperiores repellat. Nam libero tempore cum soluta nobis est eligendi
          optio cumque nihil impedit quo minus id quod maxime placeat facere
          possimus omnis voluptas assumenda est. Omnis dolor repellendus
          temporibus autem quibusdam et aut officiis debitis aut rerum
          necessitatibus saepe eveniet ut et voluptates repudiandae sint et
          molestiae non recusandae itaque earum rerum hic tenetur, please email
          <a href="mailto:yo@dev.to">lorem@ipsum.to</a>. Nemo enim ipsam
          voluptatem quia voluptas sit aspernatur aut odit aut fugit.
        </p>

        <h3 id="site-terms-of-use-modifications">
          8. Perferendis Doloribus Asperiores
        </h3>

        <p>
          Nam libero tempore cum soluta nobis est eligendi optio cumque nihil
          impedit quo minus id quod maxime placeat facere possimus omnis
          voluptas assumenda est omnis dolor repellendus temporibus autem
          quibusdam et aut officiis debitis.
        </p>

        <h3 id="dev-trademarks-and-logo-policy">
          9. Occaecati Cupiditate Non Provident
        </h3>

        <p>
          Similique sunt in culpa qui officia deserunt mollitia animi, id est
          laborum et dolorum fuga et harum quidem rerum facilis est et expedita
          distinctio nam libero tempore cum soluta nobis est eligendi optio
          cumque nihil impedit quo minus. Itaque earum rerum hic tenetur a
          sapiente delectus <a href="mailto:yo@dev.to">lorem@ipsum.to</a> ut aut
          reiciendis voluptatibus maiores alias consequatur.
        </p>

        <h3 id="reserved-names">10. Similique Sunt In Culpa</h3>

        <p>
          Qui officia deserunt mollitia animi id est laborum et dolorum fuga et
          harum quidem rerum facilis est et expedita distinctio. Nam libero
          tempore cum soluta nobis est eligendi optio cumque nihil impedit quo
          minus id quod maxime placeat facere possimus omnis voluptas assumenda.
        </p>

        <p>
          Est omnis dolor repellendus temporibus autem quibusdam et aut officiis
          debitis aut rerum necessitatibus saepe eveniet ut et voluptates
          repudiandae sint et molestiae non recusandae itaque earum rerum hic
          tenetur a sapiente delectus.
        </p>

        <h3 id="content-policy">11. Voluptates Repudiandae</h3>

        <p>
          Temporibus autem quibusdam et aut officiis debitis aut rerum
          necessitatibus saepe eveniet ut et voluptates repudiandae sint:
        </p>
        <ul>
          <li>
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusantium doloremque laudantium totam rem aperiam eaque ipsa quae
            ab illo inventore veritatis.
          </li>
          <li>
            Neque porro quisquam est qui dolorem ipsum quia dolor sit amet
            consectetur adipisci velit sed quia non numquam eius modi tempora.
          </li>
          <li>
            Ut enim ad minima veniam quis nostrum exercitationem ullam corporis
            suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur:
            “Quis autem vel eum iure reprehenderit qui in ea voluptate velit
            esse quam nihil molestiae consequatur.”
          </li>
        </ul>
        <p></p>

        <p>
          At vero eos et accusamus et iusto odio dignissimos ducimus qui
          blanditiis praesentium voluptatum deleniti atque corrupti quos
          dolores et quas molestias excepturi sint occaecati cupiditate non
          provident. Similique sunt in culpa qui officia deserunt mollitia
          animi id est laborum.
        </p>

        <h3 id="governing-law">12. Nemo Enim Ipsam</h3>

        <p>
          Voluptatem quia voluptas sit aspernatur aut odit aut fugit sed quia
          consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt
          neque porro quisquam est.
        </p>

        <p>Qui dolorem ipsum quia dolor sit amet consectetur adipisci velit.</p>
      </div>
    </FadeIn>
  );
}
